import { useEffect, useState } from "react";
import { UserRole } from "../../data/userRole";
import { addUserRole, getRoles, getUsersRoles, updateUserRole } from "../../services/adminServices";
import { UserInfo } from "../../data/userInfo";
import { getUsers } from "../../services/UserInfo";
import { LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import {v4 as uuidv4} from 'uuid';

import './Admin.css';

export default function UserRoles() {
    const [rolesList, setRolesList] = useState<string[]>();
    const [usersRolesList, setUsersRoles] = useState<UserRole[]>();
    const [usersList, setUsersList] = useState<UserInfo[]>([]);
    useEffect(()=>{
        const fetchRoles = async () => {
            const tempRoles = await getRoles();
            setRolesList(tempRoles);
        };
        const fetchUsersRoles = async () => {
            const tempUsersRolesList = await getUsersRoles();
            setUsersRoles(tempUsersRolesList);
        };
        const fetchUsers = async () => {
            const tempUsersList = await getUsers();
            setUsersList(tempUsersList);
        };
        fetchRoles();
        fetchUsers();
        fetchUsersRoles();
    },[]);

    /*************** - Begin - Table Code - Begin - /***************/
    const FilterUserRole=(Id:string) =>{
        const userrole: UserRole[]|undefined = usersRolesList?.filter(function (el) {
            //alert(el.UserId+"\n"+Id)
            return el.UserId=== Id;
        });
        return userrole!==undefined?userrole[0]:undefined;
    };
    const IsRoleSelected=(Id:string, role:string)=>{
        const userrole = FilterUserRole(Id);
        if(userrole===undefined || userrole.UserRolesList===undefined)
            return false;
        const matchingRoles: string[]|undefined = userrole.UserRolesList.filter(function (el) {
            return el=== role;
        });
        return matchingRoles.length>0;
    };
    const RefreshList = () =>{
        let tempUserRoles: UserRole[]=JSON.parse(JSON.stringify(usersRolesList));
        setUsersRoles(tempUserRoles);
        let tempUsersList: UserInfo[]=JSON.parse(JSON.stringify(usersList));
        setUsersList(tempUsersList);
    };
    const SelectionChanged = async (Id:string, role: string)=>{
        if(usersRolesList===undefined)
            return;
        let userFound = false;
        for(let i=0; i< usersRolesList.length; i++){
            if(usersRolesList[i].UserId === Id){
                userFound=true;
                let hasRole: boolean=false;
                for(let r = 0; r< usersRolesList[i].UserRolesList.length; r++){
                    if(usersRolesList[i].UserRolesList[r] === role){
                        hasRole=true;
                        let tempUserRole=usersRolesList[i];
                        tempUserRole.UserRolesList.splice(r, 1);
                        const tempUpdateResult = await updateUserRole(tempUserRole);
                        if(tempUpdateResult!==undefined){
                            usersRolesList[i]=tempUpdateResult;
                            RefreshList();
                            return;
                        }
                    }
                }
                if(hasRole===false){
                    usersRolesList[i].UserRolesList.push(role);
                    let tempUserRole=usersRolesList[i];
                    const tempUpdateResult = await updateUserRole(tempUserRole);
                    if(tempUpdateResult!==undefined){
                        usersRolesList[i]=tempUpdateResult;
                        RefreshList();
                        return;
                    }
                }
            }
        }
        if(userFound===false)
        {
            let newUuid = uuidv4();
            let newUserRole: UserRole= {
                Id: newUuid,
                UserId: Id,
                UserRolesList: [role]
              }
              const tempAddResult = await addUserRole(newUserRole);
              if(tempAddResult!==undefined){
                usersRolesList.push(tempAddResult);
                RefreshList();
              }
        }
        // if(userrole.UserRolesList.indexOf(role)>=0)
        // const 
    };
    /*************** -  End  - Grid Configurations -  End  - /***************/
    return (
        <>
        <div>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Assigned Roles</TableCell>
                    </TableRow>
                </TableHead>
                {usersList?.length > 0 && usersList!== undefined? (
                    <TableBody>
                        {usersList?.map((row) => (
                            <TableRow
                            key={row.Id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                <div className="Profile-Image-Container">
                                    <div className="Profile-Image-Small-Images">
                                        <img src={row.PictureLink===null?
                                        "https://internationalwomensday.s3-us-west-2.amazonaws.com/images/IWD-WomenSpeakers.jpg"
                                        :row.PictureLink}/>
                                    </div>
                                    <div className="Profile-Name">
                                        {row.FirstName} {row.LastName}
                                    </div>
                                </div>
                                </TableCell>
                                <TableCell align="right">
                                    <div>
                                        {
                                            rolesList?.map((role:string)=>(
                                                <>
                                                    <input type="checkbox" id={row.Id+"-"+role} checked={IsRoleSelected(row.Id??"", role)} onChange={()=>{SelectionChanged(row.Id??"", role)}}></input>
                                                    <label >{role}</label>
                                                </>
                                            ))
                                        }
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    ) : (
                    <TableBody>
                        <TableRow>
                            <TableCell align="center" colSpan={2}>
                                <LinearProgress  color="info"/>
                            </TableCell>
                        </TableRow>   
                    </TableBody>
                )}
                
            </Table>
            </TableContainer>
        </div>
        </>
    );
}
